import { UPDATE_REFERRAL } from "../../../mutations/referrals";

import { useMutation } from "@apollo/client";
import { useDispatch } from "react-redux";
import { enqueueSnackbar } from "../../../state/ducks/notifiers";

const useUpdateReferral = () => {
  const dispatch = useDispatch();
  const [updateReferral] = useMutation(UPDATE_REFERRAL, {
    onCompleted: (response) => {
      dispatch(
        enqueueSnackbar({
          message: `Referral ${response?.updateReferral?.displayableId} updated!`,
          options: {
            variant: "success",
          },
        })
      );
    },
    onError: () => {
      dispatch(
        enqueueSnackbar({
          message: `Failed while updating the referral`,
          options: { variant: "error" },
        })
      );
    },
  });

  return { updateReferral };
};

export default useUpdateReferral;
